<div class="selector">
    <div class="icon">
        <i ng-if="widget.type==='search'" class="fa fa-search"></i>
        <i ng-if="widget.type==='services'" class="fa fa-th"></i>
        <i ng-if="widget.type==='workflowList'" class="fa fa-th-list"></i>
        <i ng-if="widget.type==='contractList'" class="fa fa-th-list"></i>
        <i ng-if="widget.type==='transcriptList'" class="fa fa-th-list"></i>
        <i ng-if="widget.type==='taskList'" class="fa fa-th-list"></i>
        <i ng-if="widget.type==='bucket'" class="fa fa-list-ol"></i>
        <i ng-if="widget.type==='workCount'" class="fa fa-list-ol"></i>
        <i ng-if="widget.type==='taskCount'" class="fa fa-list-ol"></i>
    </div>
    <div class="info">
        <div>{{widget.title | translate}}</div>
        <p>{{widget.description | translate}}</p>
    </div>
    <c-checkbox checked="widget.visible"></c-checkbox>
</div>
